<template>
  <div class="border p-2 shadow-xl rounded h-full flex justify-center">
    <img
      :src="img.src"
      @error="defaultImage"
      class="
        cursor-pointer
        hover:opacity-75
        transition
        duration-500
        ease-in-out
        mx-auto
        object-contain
      "
      @click="handleClick"
    />
  </div>
</template>

<script>
import { generateFullPath } from "../../utils/fileHelpers";

export default {
  name: "EachImage",

  props: {
    img: Object,
  },

  methods: {
    handleClick() {
      window.open(this.img.downloadPath);
    },

    defaultImage(e) {
      e.target.src = generateFullPath("/img/med_st_team.png");
    },
  },
};
</script>